import React from "react";
import { SvgIcon } from "@progress/kendo-react-common";
import { reorderIcon } from "@progress/kendo-svg-icons";
import ReorderContext from "components/CaseFiles/ReorderContext";

export const DragHandleCell = (props) => {
  const context = React.useContext(ReorderContext);

  return (
    <td
      style={{ touchAction: "none", textAlign: "center" }}
      onDragOver={(e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
      }}
      onDrop={(e) => {
        e.preventDefault();
        context.reorder(props.dataItem);
      }}
    >
      <span
        draggable={true}
        style={{
          cursor: "move",
        }}
        onDragStart={(e) => {
          context.dragStart(props.dataItem);
          e.dataTransfer.setData("text/plain", "dragging");
          e.dataTransfer.effectAllowed = "move";
        }}
      >
        <SvgIcon icon={reorderIcon} />
      </span>
    </td>
  );
};

export const DropableRowWrapper = (props) => {
  const context = React.useContext(ReorderContext);
  const [isDragOver, setIsDragOver] = React.useState(false);

  const DropableRow = (row, rowProps) => {
    return React.cloneElement(row, {
      onDragOver: (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
        setIsDragOver(true);
      },
      onDragLeave: (e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
          setIsDragOver(false);
        }
      },
      onDrop: (e) => {
        e.preventDefault();
        context.reorder(rowProps.dataItem);
        setIsDragOver(false);
      },
      style: {
        ...row.props.style,
        cursor: "pointer",
        backgroundColor: isDragOver
          ? "#f0f8ff"
          : row.props.style?.backgroundColor || "transparent",
        boxShadow: isDragOver ? "0 0 8px rgba(0, 123, 255, 0.3)" : "none",
        transition: "all 0.2s ease",
      },
    });
  };

  return DropableRow(props.row, props.rowProps);
};
